export default "__VITE_PUBLIC_ASSET__e66a40e6__"